import { useInboxEntryCommentsStore } from '../../store';
import { INITIAL_ENTRY_STATE } from '../../store/InboxEntryComments/handlers';

export const useInboxEntryCommentsSlice = (inboxEntryId: string) => {
  const entryState = useInboxEntryCommentsStore(
    (state) => state.stateByEntry[inboxEntryId] ?? INITIAL_ENTRY_STATE,
  );

  const initEntry = useInboxEntryCommentsStore((state) => state.initEntry);
  const clearEntry = useInboxEntryCommentsStore((state) => state.clearEntry);
  const setComments = useInboxEntryCommentsStore((state) => state.setComments);
  const appendComments = useInboxEntryCommentsStore(
    (state) => state.appendComments,
  );
  const addComment = useInboxEntryCommentsStore((state) => state.addComment);
  const updateComment = useInboxEntryCommentsStore(
    (state) => state.updateComment,
  );
  const removeComment = useInboxEntryCommentsStore(
    (state) => state.removeComment,
  );
  const replaceComment = useInboxEntryCommentsStore(
    (state) => state.replaceComment,
  );
  const setLoading = useInboxEntryCommentsStore((state) => state.setLoading);
  const setLoadingMore = useInboxEntryCommentsStore(
    (state) => state.setLoadingMore,
  );
  const setError = useInboxEntryCommentsStore((state) => state.setError);
  const setEditingCommentId = useInboxEntryCommentsStore(
    (state) => state.setEditingCommentId,
  );
  const setCreatingComment = useInboxEntryCommentsStore(
    (state) => state.setCreatingComment,
  );
  const setUpdatingCommentId = useInboxEntryCommentsStore(
    (state) => state.setUpdatingCommentId,
  );
  const setDeletingCommentId = useInboxEntryCommentsStore(
    (state) => state.setDeletingCommentId,
  );

  return {
    ...entryState,
    initEntry: () => initEntry(inboxEntryId),
    clearEntry: () => clearEntry(inboxEntryId),
    setComments: (
      comments: Parameters<typeof setComments>[1],
      exclusiveStartKey: Parameters<typeof setComments>[2],
    ) => setComments(inboxEntryId, comments, exclusiveStartKey),
    appendComments: (
      comments: Parameters<typeof appendComments>[1],
      exclusiveStartKey: Parameters<typeof appendComments>[2],
    ) => appendComments(inboxEntryId, comments, exclusiveStartKey),
    addComment: (comment: Parameters<typeof addComment>[1]) =>
      addComment(inboxEntryId, comment),
    updateComment: (comment: Parameters<typeof updateComment>[1]) =>
      updateComment(inboxEntryId, comment),
    removeComment: (commentId: Parameters<typeof removeComment>[1]) =>
      removeComment(inboxEntryId, commentId),
    replaceComment: (
      tempId: Parameters<typeof replaceComment>[1],
      comment: Parameters<typeof replaceComment>[2],
    ) => replaceComment(inboxEntryId, tempId, comment),
    setLoading: (isLoading: Parameters<typeof setLoading>[1]) =>
      setLoading(inboxEntryId, isLoading),
    setLoadingMore: (isLoadingMore: Parameters<typeof setLoadingMore>[1]) =>
      setLoadingMore(inboxEntryId, isLoadingMore),
    setError: (error: Parameters<typeof setError>[1]) =>
      setError(inboxEntryId, error),
    setEditingCommentId: (
      commentId: Parameters<typeof setEditingCommentId>[1],
    ) => setEditingCommentId(inboxEntryId, commentId),
    setCreatingComment: (creating: Parameters<typeof setCreatingComment>[1]) =>
      setCreatingComment(inboxEntryId, creating),
    setUpdatingCommentId: (
      commentId: Parameters<typeof setUpdatingCommentId>[1],
    ) => setUpdatingCommentId(inboxEntryId, commentId),
    setDeletingCommentId: (
      commentId: Parameters<typeof setDeletingCommentId>[1],
    ) => setDeletingCommentId(inboxEntryId, commentId),
  };
};
